import React from 'react';
import { ExternalLinkIcon, PuzzleIcon, HeartHandshakeIcon, TabletSmartphoneIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { backing } from '../data/content';
const styles = [{
  icon: PuzzleIcon,
  tint: '#E6F2FB',
  accent: '#6CBBD5'
}, {
  icon: HeartHandshakeIcon,
  tint: '#FDEAEC',
  accent: '#F27C70'
}, {
  icon: TabletSmartphoneIcon,
  tint: '#E9F6EE',
  accent: '#2D8C5A'
}];
export function Backing() {
  return <section className="w-full bg-cream2 py-16 sm:py-20" aria-labelledby="backing-title" data-id="element-22" data-mp="34jnfwft71mhg">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-23" data-mp="39hylufgdbcue">
        <Reveal data-id="element-24" data-mp="3dj0n11tuhyz0">
          <p className="text-center font-display text-[11px] font-extrabold uppercase tracking-[0.2em] text-tangerine" data-id="element-25" data-mp="3diiofyjpn8nx">
            Lo que dice la evidencia
          </p>
          <h2 id="backing-title" className="mx-auto mt-3 max-w-2xl text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-26" data-mp="2lrulqi2e1v85">
            Jugar es mucho más que <span className="text-brandgreen" data-id="element-27" data-mp="2mxhl5lsbi7gi">pasar el tiempo</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center font-sans text-sm leading-relaxed text-muted sm:text-base" data-id="element-28" data-mp="2hyddizl1khsa">
            Menos pantallas, más crear juntos.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-29" data-mp="288lcbmifsqeu">
          {backing.map((b, i) => {
          const s = styles[i % styles.length];
          const Icon = s.icon;
          return <Reveal as="article" key={b.title} delay={i * 0.08} data-id="element-30" data-mp="1z740whfz5cwh" data-mpi={i}>
                <div className="flex h-full flex-col rounded-3xl bg-white p-6 transition-transform duration-300 hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
              borderTop: `5px solid ${s.accent}`
            }} data-id="element-31" data-mp="1z9zyu5rto1kx">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl" style={{
                backgroundColor: s.tint
              }} data-id="element-32" data-mp="3ok7hyquff7vl">
                    <Icon className="h-5 w-5" style={{
                  color: s.accent
                }} aria-hidden="true" data-id="element-33" data-mp="1hw88i5ow2au4" />
                  </span>
                  <h3 className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.1em]" style={{
                color: s.accent
              }} data-id="element-34" data-mp="18059h8pc2sbe">
                    {b.title}
                  </h3>
                  <p className="mt-3 flex-1 font-sans text-sm leading-relaxed text-muted" data-id="element-35" data-mp="20q419buwx3jr">
                    {b.text}
                  </p>
                  <a href={b.href} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-1.5 font-sans text-xs text-navy/60 underline decoration-navy/20 underline-offset-4 transition-colors hover:text-navy" data-id="element-36" data-mp="25ljdy0h6otel">
                    {b.source}
                    <ExternalLinkIcon className="h-3 w-3" aria-hidden="true" data-id="element-37" data-mp="kc43a6fmnnz5" />
                  </a>
                </div>
              </Reveal>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center font-sans text-[11px] leading-relaxed text-muted/80" data-id="element-38" data-mp="2ti5y9ioget20">
          Estas referencias respaldan principios generales relacionados con juego e
          interacción familiar y no constituyen un aval específico de El Gran Reto Creativo.
        </p>
      </div>
    </section>;
}